/**
 * @description 滚动深度计算与字段组装：保证 25→50→75→100 升序、统一 scroll_depth
 */

import { SCROLL_DEPTH_THRESHOLDS } from './constants'

/**
 * @description 计算滚动百分比；内容不可滚动时视为已完整浏览（100）
 * @param {number} scrollTop
 * @param {number} maxScroll - scrollHeight - clientHeight
 * @returns {number} 0–100
 */
export function calcScrollPercent(scrollTop, maxScroll) {
  if (!Number.isFinite(maxScroll) || maxScroll <= 0) return 100
  const top = Math.max(0, Number(scrollTop) || 0)
  return Math.min(100, Math.round((top / maxScroll) * 100))
}

/**
 * @description 按 25→50→75→100 升序返回本次新达到的阈值（不跳档、不乱序）
 * @reason 短页不可滚动时只报 100，避免一次冒出 25/50/75/100 串档
 * @param {number} percent
 * @param {Set<number>|null|undefined} reachedSet
 * @param {{ shortPage?: boolean }} [options]
 * @returns {number[]}
 */
export function getNewlyReachedScrollThresholds(percent, reachedSet, options = {}) {
  const p = Math.min(100, Math.max(0, Number(percent) || 0))
  const thresholds = options.shortPage ? [100] : SCROLL_DEPTH_THRESHOLDS
  const newly = []
  for (const threshold of thresholds) {
    if (p < threshold) break
    if (reachedSet && reachedSet.has(threshold)) continue
    newly.push(threshold)
  }
  return newly
}

/**
 * @description 组装滚动深度统一字段（监控可读 scroll_depth）
 * @param {number} threshold
 * @param {Record<string, any>} [extra]
 * @returns {Record<string, any>}
 */
export function buildScrollDepthProperties(threshold, extra = {}) {
  const depthValue = Number(threshold)
  return {
    ...extra,
    scroll_depth: depthValue,
    depth_threshold: depthValue,
    depth_percent: depthValue,
  }
}
